/**
 * Replaces or removes an element from an array.
 * @param array
 * @param oldItem
 * @param newItem
 * @returns
 */
export const itemReplacer = <T>(array: T[], oldItem: T, newItem?: T): T[] => {
	if (newItem) {
		return array.map((item) => (item === oldItem ? newItem : item));
	} else {
		return array.filter((item) => item !== oldItem);
	}
};
